import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import cn from 'classnames';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import cleanLinkSrc from '../../../utils/xss/cleanLinkSrc';
import s from './DeviationLink.scss';
const getUrl = (url)=>{
    if (!/^http/.test(url)) {
        return `http://${url}`;
    }
    return url;
};
const EditorDeviationLink = ({ className , style , link , deviation , children  })=>{
    const linkProps = {
        className: cn(s['link'], className),
        style
    };
    return link ? /*#__PURE__*/ React.createElement("a", _extends({}, linkProps, {
        href: cleanLinkSrc(getUrl(link.url)),
        rel: "nofollow noopener"
    }), children) : /*#__PURE__*/ React.createElement(DeviationLink, _extends({}, linkProps, {
        deviation: deviation,
        canLinkToStash: deviation.isJournal
    }), children);
};
EditorDeviationLink.displayName = 'EditorDeviationLink';
export default EditorDeviationLink;
